
import { Button } from "@/components/ui/button";
import { goToHeroOrderForm } from '@/lib/utils';


const BreakthroughSection = () => {
  
  
  return (
    <section className="bg-gradient-to-b from-book-darkBlue via-book-darkBlue/95 to-book-blue/90 py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-8 text-white leading-tight">
            It's Time To Break Through <br className="hidden md:block"/>
            Your Growth Ceiling
          </h2>
          
          <p className="text-lg text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed">
            Most ERP consultants hit a wall in their career. You can either keep trading time for money in a corporate job, or you can build a independent consulting business that gives you both financial freedom and control over your life.
          </p>
          
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16">
            <div className="w-full md:w-1/2">
              <Button 
                onClick={goToHeroOrderForm}
                className="bg-book-yellow hover:bg-book-yellow/90 text-book-darkBlue font-bold py-3 px-8 text-base uppercase tracking-wide shadow-lg transition-all duration-300 w-full md:w-auto rounded-md" 
                size="lg"
              >
                Rush Me A Free Copy
              </Button>
            </div>
            
            <div className="w-full md:w-1/2 mt-10 md:mt-0">
              <div className="relative">
                <div className="absolute -inset-4 bg-book-yellow/20 blur-md rounded-lg"></div>
                <img 
                  src="/lovable-uploads/5d957989-2eed-4940-80e1-1982942766f6.png" 
                  alt="The Liberated Consultant Book Cover" 
                  className="mx-auto h-64 object-contain drop-shadow-xl relative z-10"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BreakthroughSection;
